import React from 'react';
import { LegendProps } from 'recharts';

import * as Styled from 'dashboard/styles/Recharts.style';

interface CustomLegendProps extends LegendProps {
  isDesktop?: boolean;
}

export default function CustomLegend({
  payload,
  isDesktop,
}: CustomLegendProps) {
  if (!payload?.length) return null;

  if (isDesktop) {
    return (
      <Styled.LegendVertical>
        {payload.map((entry) => (
          <Styled.LegendVerticalItem key={entry.value}>
            <Styled.Dot $color={entry.color} />
            <Styled.LegendVerticalText>{entry.value}</Styled.LegendVerticalText>
          </Styled.LegendVerticalItem>
        ))}
      </Styled.LegendVertical>
    );
  }

  const reversed = [...payload].reverse();

  return (
    <Styled.Legend>
      {reversed.map((entry) => (
        <Styled.LegendItem key={entry.value}>
          <Styled.Dot $color={entry.color} />
          <Styled.LegendItemText>{entry.value}</Styled.LegendItemText>
        </Styled.LegendItem>
      ))}
    </Styled.Legend>
  );
}
